const React = require('react');

import Swiper from 'react-id-swiper';
import HttpsProtocolImage from '../common/https-protocol-image.jsx';
import BoardGoback from '../../component/mui/show-board/show-goback.jsx';
const DishListItem = require('./dish-list-item.jsx');
import defaultLogo from '../../asset/images/dish_img_default.svg';
require('./dish-list-item.scss');
const classnames = require('classnames');
import 'react-id-swiper/src/styles/scss/swiper.scss';
require('./dish-hot-slide.scss');
import immutable from 'seamless-immutable';

import { formatMessage } from '../../intl/helper';
import globalMessages from './../../intl/messages/global';

const DishHotSlide = React.createClass({
  propTypes: {
    goBack: React.PropTypes.func,
    theme: React.PropTypes.string,
    dishesData: React.PropTypes.array.isRequired,
    sameRuleDishList: React.PropTypes.array,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    onPropsBtnTap: React.PropTypes.func.isRequired,
    onImageBtnTap: React.PropTypes.func.isRequired,
    diningForm: React.PropTypes.number,
    marketList: React.PropTypes.object,
    soldTopDishList: React.PropTypes.array,
  },
  getInitialState() {
    return ({
      hotActiveIndex: 0,
    });
  },
  onOrderDishUpdateInfo: {},

  onDishBtnTap(dishData, action) {
    const { onOrderBtnTap, onPropsBtnTap } = this.props;
    if (action) {
      this.onOrderDishUpdateInfo = {
        dishData,
        action,
      };
      onOrderBtnTap(immutable(dishData), action);
    } else {
      onPropsBtnTap(immutable(dishData));
    }
  },

  setActiveIndex(num) { // 设置图片索引
    this.setState({ hotActiveIndex: num });
  },

  setDishTypeDataHot() {
    const dishHotItem = this.props.soldTopDishList.map((temp, i) => {
      const { sameDishIndexs } = temp;
      const sameRuleDishList = sameDishIndexs ? sameDishIndexs.map(dishIndex => this.props.dishesData[dishIndex]) : null;
      return (
        <li key={i} className={classnames('dish-item-dish', { 'last-item': i === length - 1 })}>
          <div style={{ position: 'relative' }}>
            {this.state.hotActiveIndex !== i && <div className="hot-hid"></div>}
            <DishListItem
              theme="huge"
              dishData={temp}
              sameRuleDishList={sameRuleDishList}
              onOrderBtnTap={this.onDishBtnTap}
              onPropsBtnTap={this.onDishBtnTap}
              onImageBtnTap={this.props.onImageBtnTap}
              marketList={this.props.marketList}
              diningForm={this.props.diningForm}
              hotTag
              showHandleInput={this.props.showHandleInput}
            />
          </div>
        </li>
      );
    });

    return dishHotItem;
  },

  gobackAction() {
    location.hash = '';
  },

  render() {
    const listSmallElement = this.props.soldTopDishList.map((item, index) => {
      let hotNum = '';
      switch (index) {
        case 0:
          hotNum = 'hotNum hotNum_0';
          break;
        case 1:
          hotNum = 'hotNum hotNum_1';
          break;
        case 2:
          hotNum = 'hotNum hotNum_2';
          break;
        default:
          break;
      }
      const imgStyle = item.smallImgUrl || item.largeImgList[0] ? 'mediuImg' : 'smallImg';
      return (
        <div
          key={index}
          className={classnames('o-mt hot-item', { 'o-ml': index === 0 })}
          onTouchTap={
            () => { this.swiperBig.slideTo(index, 1000, false); this.setActiveIndex(index); this.swiperSmall.slideTo((index - 1), 1000, false); }
          }
          style={{ right: '7px' }}
        >
          <div className={classnames('small-item', { 'small-item-active': this.state.hotActiveIndex === index })}>
            <i className={hotNum}></i>
            <HttpsProtocolImage src={item.smallImgUrl || item.largeImgList[0] || defaultLogo} alt="" className={imgStyle} />
          </div>
        </div>
      );
    });

    const listBigElement = this.setDishTypeDataHot();

    return (
      <div className="o-bg-grey dish-hot">
        <div className="dish-hot-blur"></div>
        <BoardGoback gobackAction={this.props.goBack} title={formatMessage(globalMessages.goToOrder)} />
        <div className="hot-list-small">
          <Swiper
            slidesPerView={4.3}
            onInit={(swiper) => { this.swiperSmall = swiper; }}
            initialSlide={0}
            slideToClickedSlide

          >
          {listSmallElement}
          </Swiper>
        </div>
        <div className="hot-list-big">
          <Swiper
            spaceBetween={-70}
            slidesPerView={1}
            initialSlide={0}
            nextButton={listBigElement.length > 1 ? '.swiper-button-next' : ''}
            prevButton={listBigElement.length > 1 ? '.swiper-button-prev' : ''}
            onInit={(swiper) => { this.swiperBig = swiper; }}
            onSlideChangeStart={(swiper) => { this.swiperSmall.slideTo(swiper.activeIndex, 1000, false); this.setActiveIndex(swiper.activeIndex); }}
          >
            {listBigElement}
          </Swiper>
        </div>
        <div style={{ height: '56px' }}></div>
      </div>
    );
  },
});

module.exports = DishHotSlide;



// WEBPACK FOOTER //
// ./src/component/dish-menu/dish-hot-slide.jsx